import React from "react";
import moment from "moment";
import {Decryption} from "./function";
import {HRMS_STATUS} from "./constant";

export const prepareNonWorkingHour = (array = []) => {
    const data = []
    array.forEach((e, i) => {
        const next = array[i + 1]
        data.push(e)
        if (next) {
            const obj = {}
            obj.type = HRMS_STATUS?.TIME_SHEET_TYPE.BREAK
            obj.inTime = e.outTime
            if(e.break) obj.break = e.break
            obj.outTime = next.inTime
            obj.totalTime = (new Date(obj.outTime).getTime() - new Date(obj.inTime).getTime()) / 1000
            obj.breakReason = e.breakReason
            obj.inTimeIP = e.outTimeIP
            obj.outTimeIP = next.inTimeIP
            obj.prevId = e._id
            obj.nextId = next._id
            data.push(obj)
        }
    })
    return data
}
export const prepareNonWorkingHourDashboard = (array = []) => {
    const data = []
    array.forEach((e, i) => {
        const next = array[i + 1]
        data.push(e)
        if (next) {
            const obj = {}
            obj.type = HRMS_STATUS?.TIME_SHEET_TYPE.BREAK
            obj.inTime = e.outTime
            obj.outTime = next.inTime
            obj.totalTime = (new Date(obj.outTime).getTime() - new Date(obj.inTime).getTime()) / 1000
            obj._id = e._id
            data.push(obj)
        }
    })
    return data
}
export const requestTicket = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (!data.search) delete data.search
    if (data.category) data.category = data?.category?.value ?? data?.category?._id;
    else delete data.category
    if (data.status) data.status = data?.status?.value ?? data?.status?._id;
    else delete data.status
    if (data?.tags?.length > 0) {
        const finalArray = []
        data.tags?.forEach(e => finalArray?.push(e?.value || e?._id))
        data.tags = finalArray
    } else delete data.tags
    if (data?.employee) data.createdBy = data?.employee?.value ?? data?.employee?._id
    if (data?.assignTo) data.assignTo = data?.assignTo?.value ?? data?.assignTo?._id
    else delete data.assignTo
    if (data?.priority) data.priority = data?.priority?.value ?? data?.priority?._id
    else delete data.priority
    if (!data?.createdAt?.startDate) delete data.createdAt
    if (!data?.dueDate?.startDate) delete data.dueDate
    if (data?.ticket && data?.ticket !== 'allTicket') data.isResolved = data?.ticket !== 'openTicket'
    delete data.ticket

    if (data?.location?.value) data.location = [data.location?.value]
    else delete data.location
    if (data?.companyId?.value) data.companyId = [data.companyId?.value]
    else delete data.companyId


    delete data.employee
    return data
}

export const checkDate = (date) => {
    // 'Older',
    // 'Yesterday',
    // 'Today',
    // 'Tomorrow',
    // 'This Week',
    // 'This Month',
    // 'Upcoming',
    // 'No Due Date'

    const FORMAT = 'YYYY-MM-DD'
    const momentDate = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    const TOMORROW = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_START = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_END = REFERENCE.clone().endOf('week')
    const MONTH_END = REFERENCE.clone().endOf('month').add(1, 'days').startOf('day');
    const MONTH_NEXT = REFERENCE.clone().endOf('month').startOf('day');

    if (momentDate.isBefore(YESTERDAY)) {
        return 'Older';
    } else if (momentDate.isSame(YESTERDAY, 'd')) {
        return 'Yesterday';
    } else if (momentDate.isSame(TODAY, 'd')) {
        return 'Today';
    } else if (momentDate.isSame(TOMORROW, 'd')) {
        return 'Tomorrow';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_START.clone().format(FORMAT), WEEK_END.clone().format(FORMAT))) {
        return 'This Week';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_END.clone().format(FORMAT), MONTH_END.clone().format(FORMAT))) {
        return 'This Month';
    } else if (momentDate.isAfter(MONTH_NEXT)) {
        return 'Upcoming';
    } else {
        return 'No Due Date';
    }
}
export const socketHandler = (response) => {
    if (typeof response === 'string') return Decryption(response);
    else return response;
}

export const requestTask = (filter) => {
    const data = JSON.parse(JSON.stringify(filter));

    if (data.sortBy) data.sortBy = data.sortBy.value;
    if (data.tasks) data.tasks = data.tasks.value;
    if (data.project) data.project = data.project.value;
    if (data?.tag?.length > 0) {
        const finalArray = []
        data.tag?.forEach(e => finalArray?.push(e?.value || e?._id))
        data.tag = finalArray
    } else delete data.tag
    if (data.assignTo) data.assignTo = data.assignTo.value === '-' ? null : data.assignTo.value
    else delete data.assignTo
    if (data.createdBy) data.createdBy = data.createdBy.value
    else delete data.createdBy
    if (data.taskType) data.taskType = data.taskType.value
    else delete data.taskType
    if (data.priority) data.priority = data.priority.value
    else delete data.priority
    if (data.taskStatus) data.taskStatus = data.taskStatus.value
    else delete data.taskStatus

    if (data.dueDate && data.dueDate.value) {
        switch (data.dueDate.value) {
            case 'beforeToday': {
                data.beginTime = 0;
                data.endTime = new Date(moment().startOf('day')).getTime() - 1;
                break;
            }
            case 'today': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('day')).getTime();
                break;
            }
            case 'tomorrow': {
                data.beginTime = new Date(moment().add(1, 'days').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'days').endOf('day')).getTime();
                break;
            }
            case 'thisWeek': {
                data.beginTime = new Date(moment().startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'nextWeek': {
                data.beginTime = new Date(moment().add(1, 'week').startOf('isoWeek').startOf('day')).getTime();
                data.endTime = new Date(moment().add(1, 'week').endOf('isoWeek').endOf('day')).getTime();
                break;
            }
            case 'next14': {
                data.beginTime = new Date(moment().startOf('day')).getTime();
                data.endTime = new Date(moment().add(14, 'days').endOf('day')).getTime();
                break;
            }
            case 'customDate': {
                data.beginTime = new Date(moment(data?.dueCustomDate?.startDate).startOf('day')).getTime();
                data.endTime = new Date(moment(data?.dueCustomDate?.endDate).endOf('day')).getTime();
                break;
            }
            default:
                break;
        }
        delete data.dueDate;
        delete data.dueCustomDate;
    }
    return data
}
export const planMerger = (planAccess, productAccess, isAdmin) => {
    for (const key in planAccess) {
        if (planAccess[key] && planAccess[key].default) {
            planAccess[key].default.access = planAccess[key].default.access && (isAdmin || productAccess?.[key]);
        }
    }
    return planAccess
}